module.exports = __webpack_public_path__ + "static/media/20231026-DSC_7553.fdf1be36.jpg";